import type { PayloadAction } from '@reduxjs/toolkit';
import type { IToastMessagePrv, ToastStorage } from './interface';

const reset = (state: ToastStorage, action: PayloadAction) => [];

const updateMessage = (
    state: ToastStorage,
    action: PayloadAction<Partial<IToastMessagePrv> & { id: string }>,
) => {
    const matchingMessages = state.filter(message => message.id === action.payload.id);
    matchingMessages.forEach(message => {
        Object.assign(message, action.payload);
    });
};

const displayMessage = (state: ToastStorage, action: PayloadAction<IToastMessagePrv>) => [
    ...state,
    action.payload,
];

const hideMessage = (
    state: ToastStorage,
    action: PayloadAction<Partial<IToastMessagePrv> & { id: string }>,
) => {
    const matchingIndexes = action.payload.id
        ? state
              .map((item, index) => (item.id === action.payload.id ? index : -1))
              .filter(index => index >= 0)
        : state
              .map((item, index) => (item.text === action.payload.text ? index : -1))
              .filter(index => index >= 0);

    const newItems = state.filter((_, idx) => !matchingIndexes.includes(idx));
    return newItems;
};

export default Object.freeze({
    reset,
    updateMessage,
    displayMessage,
    hideMessage,
});
